import { render, staticRenderFns } from "./GmExchange.vue?vue&type=template&id=146ae0de&"
import script from "./GmExchange.vue?vue&type=script&lang=js&"
export * from "./GmExchange.vue?vue&type=script&lang=js&"
import style0 from "./GmExchange.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports